export const PDP_SIDEBAR_MENU_CLICKED = 'PDP: Sidebar Menu Clicked';
export const PDP_SELECTED_VARIANT = 'PDP: Selected Variant'
export const PDP_SPARE_PARTS_PRODUCT_CLICKED = "PDP: Spare Parts Product Clicked"
export const PDP_COMPONENTS_PRODUCT_CLICKED = "PDP: Spare Parts Product Clicked"
export const USER_LOGGED_IN = "User: Logged in"


